import React from 'react';
import styles from '../style/MenuButton.module.scss';

type PrivateProps = {
  title: string;
  id: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  active?: boolean;
  href?: string;
  target?: string;
  rel?: string;
};

export default function MenuButton({
  title,
  id,
  onClick,
  active = false,
  href,
  target = '_self',
  rel,
}: PrivateProps) {
  const className = `${styles.menuButton} ${active ? styles.active : ''}`;

  if (href) {
    return (
      <a
        id={id}
        href={href}
        target={target}
        rel={rel}
        className={className}
      >
        <div>{title}</div>
        <span className={styles.underline}></span>
      </a>
    );
  }

  return (
    <button id={id} onClick={onClick} className={className}>
      <div>{title}</div>
      <span className={styles.underline}></span>
    </button>
  );
}
